var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1447 0.534737C13.1021 0.431954 13.03 0.344105 12.9375 0.282297C12.845 0.22049 12.7363 0.1875 12.625 0.1875H1.375C1.26375 0.1875 1.15499 0.22049 1.06249 0.282299C0.969987 0.344109 0.897889 0.431961 0.855316 0.534746C0.812742 0.637532 0.801604 0.750633 0.823311 0.859748C0.845017 0.968864 0.898593 1.06909 0.977263 1.14776L6.60226 6.77274C6.65449 6.82498 6.7165 6.86641 6.78475 6.89468C6.85299 6.92295 6.92613 6.9375 7 6.9375C7.07387 6.9375 7.14702 6.92295 7.21526 6.89468C7.2835 6.86641 7.34551 6.82498 7.39774 6.77274L13.0227 1.14776C13.1014 1.06909 13.155 0.968861 13.1767 0.859744C13.1984 0.750627 13.1873 0.637523 13.1447 0.534737Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.e9111dc894769563a3c226f0e7fb0ae5.svg";
export { ForwardRef as ReactComponent };